import { TypeResponse } from 'gtd-ng-widget';

export class ProfileResponse extends TypeResponse {
  id: number;
  device_os: string;
  device_brand: string;
  device_model: string;
  ip: string;
  country_code: string;
  aff_sub: string;
  aff_sub2: string;
  aff_sub3: string;
  aff_sub4: string;
  aff_sub5: string;
  region_code: string;
  affiliate_source: string;
  hash: string;
  affiliate: profile;
  offer: profile;
  advertiser: profile;
  advertiser_brand: profile;
  created_at: number;
  updated_at: number;
  offer_url_id: number;
  user_agent: string;
}

type profile = { id: number; name: string };
